import { Component, Vue, Prop } from 'vue-property-decorator'
import { IPick } from '@/store/modules/game/interfaces'
import { IDraftPick } from '@/store/modules/draft/interfaces'
import { GetOUFantasyProjection, StatusFormat, FormatEventName } from '@/utils/GameUtils'
import { format } from 'date-fns'

@Component
export default class OverUnderResult extends Vue {
  @Prop() private readonly draftPick!: IDraftPick;

  isClassic = this.draftPick.matchup.pickA.player.aspect.id.startsWith('Z')

  private getOUPick (pick: IDraftPick): IPick {
    if (pick.matchup.pickB.player.aspect.id.toLowerCase() === 'ou') {
      return pick.matchup.pickA
    } else {
      return pick.matchup.pickB
    }
  };

  private getOUvsPick (pick: IDraftPick): IPick {
    if (pick.matchup.pickB.player.aspect.id.toLowerCase() === 'ou') {
      return pick.matchup.pickB
    } else {
      return pick.matchup.pickA
    }
  }
  
  private pickedOverOrUnder(pick: IDraftPick): string {
    return pick.matchupPosition === 'B' ? 'under' : 'over';
  };

  private vsOverOrUnder(pick: IDraftPick): string {
    return pick.matchupPosition === 'B' ? 'over' : 'under';
  };

  private render(h: any): any {
    const ou = this.getOUPick(this.draftPick)
    const ouvs = this.getOUvsPick(this.draftPick)
    
    // @ts-ignore
    const stats = this.$parent.statsFor(ou, ouvs)

    let voidRender;

    // @ts-ignore
    if (this.$parent.matchupVoid(this.draftPick)) {
      let msg = 'Did Not Play'
      // @ts-ignore
      if (this.$parent.matchupTie(this.draftPick)) {
        msg = 'Matchup Tied'
      }

      voidRender = (
        <p class='matchup-stats'>
          Matchup Voided
          <span class='newline'>{msg}</span>
        </p>
      )
    } else {
      voidRender = (<p class='matchup-stats'></p>)
    }

    return (
      <div class={`qp-drafts-detail-matchup`}>
        <div class={`pick ou ${StatusFormat(this.draftPick.status).toLowerCase()}`}>
          <div class='matchup-details'>
            <p class='matchup-name'><span>Your Pick</span>{this.pickedOverOrUnder(this.draftPick)} {GetOUFantasyProjection(ouvs)}</p>
          </div>
        </div>

        <div class={`vs ou ${StatusFormat(this.draftPick.status).toLowerCase()}`}>
          <span class='matchup-score'>{ou.player.score}</span>

          <div class='matchup-details'>
            <p class='matchup-name'><span>Points</span>{ou.player.shortName}</p>
            <p class='matchup-info'>{FormatEventName(ou)}<br />{format(ou.event.startTime, 'MM-DD-YYYY')}</p>
            <p class='matchup-stats'>{stats.a[0]}<br />{stats.a[1]}</p>
            {voidRender}
          </div>
        </div>
        <div class={`pick-title ${this.isClassic ? 'classic' : 'daily'}`}>{ this.isClassic ? 'Virtual' : 'Daily' }</div>
      </div>
    );
  }
}
